import { v4 as uuidv4 } from 'uuid';
import { CardState, DeckState, Position } from '../tabletop/types';

export function shuffleCards(deck: DeckState): DeckState {
  const newCards = [...deck.cards];

  for (let i = newCards.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newCards[i], newCards[j]] = [newCards[j], newCards[i]];
  }

  return {
    ...deck,
    cards: newCards
  };
}

export function drawCards(
  deck: DeckState,
  count: number = 1,
  position?: Position
): {
  deck: DeckState;
  drawnCards: CardState[];
} {
  const actualCount = Math.min(count, deck.cards.length);

  if (actualCount === 0) {
    return { deck, drawnCards: [] };
  }

  const updatedDeck = { ...deck };
  const drawnCards: CardState[] = [];

  const fanOffsetX = 15;
  const fanOffsetY = 15;
  const basePosition = position || { x: deck.position.x + 100, y: deck.position.y };

  for (let i = 0; i < actualCount; i++) {
    const card = updatedDeck.cards.pop();

    if (card) {
      const drawnCard: CardState = {
        ...card,
        id: uuidv4(),
        position: {
          x: basePosition.x + i * fanOffsetX,
          y: basePosition.y + i * fanOffsetY
        },
        rotation: deck.rotation,
        isFaceUp: false
      };

      drawnCards.push(drawnCard);
    }
  }

  return {
    deck: updatedDeck,
    drawnCards
  };
}

export function drawCardsFromBottom(
  deck: DeckState,
  count: number = 1,
  position?: Position
): {
  deck: DeckState;
  drawnCards: CardState[];
} {
  const actualCount = Math.min(count, deck.cards.length);

  if (actualCount === 0) {
    return { deck, drawnCards: [] };
  }

  const updatedDeck = {
    ...deck,
    cards: [...deck.cards]
  };
  const drawnCards: CardState[] = [];

  const fanOffsetX = 15;
  const fanOffsetY = 15;
  const basePosition = position || { x: deck.position.x + 100, y: deck.position.y };

  for (let i = 0; i < actualCount; i++) {
    const card = updatedDeck.cards.shift();

    if (card) {
      const drawnCard: CardState = {
        ...card,
        id: uuidv4(),
        position: {
          x: basePosition.x + i * fanOffsetX,
          y: basePosition.y + i * fanOffsetY
        },
        rotation: deck.rotation,
        isFaceUp: false
      };

      drawnCards.push(drawnCard);
    }
  }

  return {
    deck: updatedDeck,
    drawnCards
  };
}

export function cutDeck(deck: DeckState, cutPosition: number): DeckState {
  if (deck.cards.length <= 1) {
    return deck;
  }

  const validCutPosition = Math.max(0, Math.min(cutPosition, deck.cards.length - 1));

  const topPortion = deck.cards.slice(validCutPosition);
  const bottomPortion = deck.cards.slice(0, validCutPosition);

  return {
    ...deck,
    cards: [...topPortion, ...bottomPortion]
  };
}

export function createDeck(
  cards: CardState[],
  position: Position,
  name: string = 'Deck'
): DeckState {
  return {
    id: uuidv4(),
    position,
    rotation: 0,
    cards,
    name,
    faceUp: false,
    collapsed: true
  };
}
